"use strict";

exports.__esModule = true;
exports.showCofOverlay = exports.showCof = exports.clickCofNextStep = exports.clickCofCustomerSupport = exports.clickCofChangeProduct = exports.chooseCofOverview = void 0;

var _constants = require("../constants");

const eventLabel = offer => ({
  eventlabel: `subscriptionshop/cta-offer-formule?typeproduct=${offer}`
});

const showCof = (user, offer) => ({ ..._constants.eventBase,
  ...eventLabel(offer.toLowerCase()),
  ..._constants.conversionWall,
  ..._constants.show,
  ...(0, _constants.identityAccountId)(user)
});

exports.showCof = showCof;

const chooseCofOverview = (user, offer) => ({ ..._constants.eventBase,
  ...eventLabel(offer.toLowerCase()),
  ..._constants.conversionWall,
  eventaction: `click-product-overview`,
  ...(0, _constants.identityAccountId)(user)
});

exports.chooseCofOverview = chooseCofOverview;

const clickCofChangeProduct = (user, offer) => ({ ..._constants.eventBase,
  ...eventLabel(offer.toLowerCase()),
  ..._constants.conversionWall,
  ..._constants.changeProduct,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCofChangeProduct = clickCofChangeProduct;

const clickCofNextStep = (user, offer) => ({ ..._constants.eventBase,
  ...eventLabel(offer.toLowerCase()),
  ..._constants.conversionWall,
  ..._constants.nextStep,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCofNextStep = clickCofNextStep;

const clickCofCustomerSupport = (user, offer) => ({ ..._constants.eventBase,
  ...eventLabel(offer.toLowerCase()),
  ..._constants.conversionWall,
  ..._constants.customerSupport,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCofCustomerSupport = clickCofCustomerSupport;

const showCofOverlay = (user, offer) => ({ ..._constants.eventBase,
  ...eventLabel(offer.toLowerCase()),
  ..._constants.conversionWall,
  ..._constants.showOverlay,
  ...(0, _constants.identityAccountId)(user)
});

exports.showCofOverlay = showCofOverlay;